import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initializeWebAppInstall } from './utils/webAppInstall';
import { initializeAppChannel } from './utils/appChannel';
import './i18n';
import './components/workspace/WorkspaceExperience.css';

initializeAppChannel();
initializeWebAppInstall();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
